import React, { Component } from 'react';
import PropTypes from 'prop-types';

const withEnterKey = callback => {
  return event => {
    if (event.keyCode === 13) {
      event.preventDefault();
      callback(event);
    }
  };
};

class AddThumbnailByUrl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showUrlInput: false
    };
    this.showUrlInput = this.showUrlInput.bind(this);
    this.setThumbnailByUrl = this.setThumbnailByUrl.bind(this);
    this.textInput = React.createRef();
  }

  setThumbnailByUrl() {
    this.props.setThumbnailUrl(this.textInput.current.value);
  }

  showUrlInput() {
    this.setState({ showUrlInput: true });
  }

  render() {
    return (
      <div className="row mt2 text-center p2">
        {this.state.showUrlInput ? (
          <div className="add-by-url" ng-show="urlThumbnail">
            <div className="form-group">
              <label htmlFor="thumbnail_url">Enter thumbnail URL</label>
              <div className="input-group">
                <input
                  id="thumbnail_url"
                  className="form-control"
                  name="thumbnail_url"
                  placeholder="https://"
                  type="text"
                  ref={this.textInput}
                  onKeyDown={withEnterKey(this.setThumbnailByUrl)}
                />
                <div className="input-group-btn">
                  <button
                    className="btn btn-default"
                    onClick={this.setThumbnailByUrl}
                    type="button"
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <button
            type="button"
            className="btn btn-link"
            onClick={this.showUrlInput}
          >
            Add Thumbnail by URL
          </button>
        )}
      </div>
    );
  }
}

AddThumbnailByUrl.propTypes = {
  setThumbnailUrl: PropTypes.func.isRequired
};

export default AddThumbnailByUrl;
